import React from 'react';
import { ButtonToolbar, Icon, IconButton, Whisper } from 'rsuite';
import Speaker from '../SpeakerCustomFilter';
import { User } from '../../../../../../@types';

interface AddFiltroComponentProps {
  usuario: User;
}

export const AddFiltroComponent = ({ usuario }: AddFiltroComponentProps) => {
  return (
    <>
      <div id="badge" className="badge">
        novo
      </div>
      <Whisper trigger="click" placement="bottomStart" speaker={<Speaker usuario={usuario} className="popover-filtro-dinamico" />}>
        <ButtonToolbar>
          <IconButton id="add-filter" icon={<Icon icon="plus" />}>
            Adicionar filtros
          </IconButton>
        </ButtonToolbar>
      </Whisper>
    </>
  );
};
